import React from "react";
import { Box, Typography, TextField } from "@mui/material";
import { alpha } from "@mui/system";
import { DescriptionOutlined } from "@mui/icons-material";

export default function ObservacoesSection({ theme, observacoes, setObservacoes }) {
	return (
		<Box
			sx={{
				p: 2,
				bgcolor: theme.palette.background.paper,
				borderRadius: "12px",
				width: "100%",
			}}
		>
			{/* Cabeçalho */}
			<Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
				<Box
					sx={{
						backgroundColor: alpha(theme.palette.primary.main, 0.2),
						borderRadius: "10px",
						width: "35px",
						height: "35px",
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
					}}
				>
					<DescriptionOutlined
						fontSize="small"
						sx={{
							color:
								theme.palette.mode === "dark"
									? theme.palette.primary.light
									: theme.palette.primary.dark,
						}}
					/>
				</Box>
				<Typography variant="h6" sx={{ fontWeight: "bold", fontSize: "16px" }}>
					Observações
				</Typography>
			</Box>

			<TextField
				multiline
				rows={3}
				size="small"
				fullWidth
				placeholder="Adicione observações que serão incluídas no relatório..."
				value={observacoes}
				onChange={(e) => setObservacoes(e.target.value)}
				sx={{ mt: 1 }}
			/>
		</Box>
	);
}
